import { render, staticRenderFns } from "./AsignarOrdenCompraAgendaModal.vue?vue&type=template&id=671cbd17&scoped=true&"
import script from "./AsignarOrdenCompraAgendaModal.vue?vue&type=script&lang=js&"
export * from "./AsignarOrdenCompraAgendaModal.vue?vue&type=script&lang=js&"
import style0 from "./AsignarOrdenCompraAgendaModal.vue?vue&type=style&index=0&id=671cbd17&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671cbd17",
  null
  
)

export default component.exports